const initialState = {
    get: [], 
    
    
  
  };
  
  const FOActivitiesReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, get:action.payload};
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default FOActivitiesReducers;
  
  